var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B29C0480-26BF-4109-96D7-FAA1473EDC1D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shlomo_Service_Call_C_2",
    transform: "translate(-267.000000, -294.000000)",
    stroke: "#C0C0C0",
    strokeWidth: 1.77408
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(267.000000, 294.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0.88704,
    y: 0.88704,
    width: 19.22592,
    height: 19.22592,
    rx: 4.4352
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCheckbox);
export default __webpack_public_path__ + "static/media/empty-checkbox.6c7084c96b2eb8c1c2a4ae16a1257a66.svg";
export { ForwardRef as ReactComponent };